export default {
  rules: {}
}
